// extracted by mini-css-extract-plugin
export default {"request_new":"RequestNewSlinger_request_new__shyw3","action":"RequestNewSlinger_action__Juh2D"};